import type { EditorThemeClasses } from "lexical";

export const theme: EditorThemeClasses = {
  root: "p-4 border border-grey-300 rounded-md min-h-[250px] focus:outline-none focus-visible:border-grey-500",
  link: "cursor-pointer text-brand-500 underline hover:text-brand-700",
  text: {
    bold: "font-bold text-grey-900",
    underline: "underline decoration-grey-600",
    italic: "italic text-grey-800",
    strikethrough: "line-through text-grey-600",
    underlineStrikethrough: "underline line-through text-grey-700",
    overflowed: "editor-text-overflowed",
    hashtag: "editor-text-hashtag",
  },
  ltr: "ltr",
  rtl: "rtl",
  placeholder: "editor-placeholder",
  paragraph: "mb-4 text-grey-900 leading-relaxed",
  quote: "pl-4 border-l-4 border-grey-400 italic text-grey-700",
  heading: {
    h1: "pb-4 pt-6 text-4xl font-extrabold text-grey-900",
    h2: "pb-3 pt-5 text-3xl font-bold text-grey-800",
    h3: "pt-4  text-2xl font-semibold text-grey-700",
    h4: "pt-3 text-xl font-medium text-grey-600",
    h5: "pt-2 text-lg font-medium text-grey-500",
    h6: "pt-2 text-base font-medium text-grey-400",
  },
  list: {
    nested: {
      listitem: "pl-5 mt-1 space-y-1 list-none list-inside",
    },
    ol: "list-decimal ml-6 my-2 list-inside",
    ul: "list-disc ml-6 my-2 list-inside",
    listitem: "text-grey-900",
    listitemChecked: "text-brand-500 line-through",
    listitemUnchecked: "text-grey-900",
  },
  table: "border-collapse table-auto w-full border border-grey-200",
  tableRow: "border-t border-grey-200",
  tableCell: "px-4 py-3 border-grey-200 text-grey-900",
  tableCellHeader: "bg-grey-200 font-bold text-grey-800 uppercase",
  tableCellSelected: "bg-grey-300",
  tableCellPrimarySelected: "text-grey-600",
  tableCellEditing: "bg-grey-100",
  code: "rounded-md bg-grey-100 p-1",
  indent: "ml-6",
};
